import API from './api';
import { CustomerLocation, LeaseData } from './apply';

export interface SessionLogoutPayload {
  expired?: boolean;
}

export interface UserInfo {
  admin: boolean;
  firstName: string;
  lastName: string;
  roles: string[];
  email: string;
  id: string;
  phone: string;
  currentAddress?: CustomerLocation;
  currentLease?: LeaseData;
  dob?: Date;
}

export interface UserPayload {
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
}

export interface SignupResponse {
  user: Customer;
  auth_token: string;
}

export interface LoginResponse {
  customer: Customer;
  auth_token: string;
}

export interface Customer {
  _id: string;
  first_name: string;
  last_name: string;
  phone: string;
  email: string;
}

export interface CustomerSensitiveData {
  dob?: Date;
  ssn?: string;
}

export const signUp = (payload: UserPayload): Promise<SignupResponse> => {
  return API.post('signup', {
    body: JSON.stringify({
      ...payload,
      origin: 'leasing-app',
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getCurrentUserInfo: () => Promise<GetUserInfoResponse> = () =>
  API.get('users/current');

export const sendConfirmationSms = (phone: string): Promise<void> => {
  return API.get(`authenticate/${phone}`);
};

export const loginWithPin = (
  phone: string,
  pin: string
): Promise<LoginResponse> => {
  return API.post(`authenticate/${phone}`, {
    body: JSON.stringify({ pin }),
    headers: { 'Content-Type': 'application/json' },
  });
};

interface GetUserInfoResponse {
  user: {
    _id: string;
    email: string;
    first_name: string;
    last_name: string;
    phone: string;
    roles: string[];
    updated_at: string;
    admin: boolean;
    location: any;
  };
}
